import {
  domReady,
  SetAppHeight,
  detectTouch,
  orientation
} from './utilities/helpers';

// grid
import grid from './modules/grid/index';

import {
  assignColors
} from './modules/colors/index';

// navigation
  import {initNavigation} from './modules/navigation/index';

//animated introduction loading logo
import {
  animatedLogo
} from './modules/animatedlogos/logo-helpers';

// Barba
import barbamodule from './modules/barbamodule/index';
import {mailingToggle} from './modules/mailinglist/index';

var
  touch = false, // set in detectTouch
  devGridOn_rows,
  devGridOn_iso,
  devGridOn_columns,
  devGridOn_baselines,
  devGridOn_vertlines,
  orientationValue,
  flickityNav = null; // Global variable for Flickity instance

const Deploi_App = {
  init() {

    $("body").addClass("loading"); //review

    //initial load
    var animatedlogoType = "loader",
      animatedlogoTypeObject = document.querySelector('.animated-logo#loader_logo');
      // flickityNav;

      console.log("Deploi_App.init()");
      // console.log("animatedlogoTypeObject", animatedlogoTypeObject);
      // console.log("animatedlogoType", animatedlogoType);
      // console.log("flickityNav", flickityNav);

  

    animatedLogo(animatedlogoType, animatedlogoTypeObject)
    //end initial load
    SetAppHeight();
    orientation(orientationValue); // really only need to run this once - but ensure it change on resize & classes added after ajax call
    detectTouch(touch); // determine if we're on touch device or not
    assignColors();
    grid(devGridOn_rows, devGridOn_iso, devGridOn_columns, devGridOn_baselines, devGridOn_vertlines);
    mailingToggle();
  
    // Initialize Flickity and get the instance
    flickityNav = initNavigation(touch);

    // console.log("flickityNav - just beofre barbamodule", flickityNav);

    barbamodule(flickityNav, touch, devGridOn_iso, devGridOn_rows, devGridOn_columns, devGridOn_baselines, devGridOn_vertlines, orientationValue);  

  }

};
domReady(Deploi_App.init);